import { render } from "./ProfileCardContractor.vue?vue&type=template&id=3b8fd9d8&scoped=true"
import script from "./ProfileCardContractor.vue?vue&type=script&lang=ts"
export * from "./ProfileCardContractor.vue?vue&type=script&lang=ts"

import "./ProfileCardContractor.vue?vue&type=style&index=0&id=3b8fd9d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b8fd9d8"

export default script